import { useState } from 'react';

// Mark text labels attached to a selected arrow as selected too, so
// they pick up the same highlight as the arrow they belong to.
const applySelection = (s) => (prev) => {
    const selectedArrowIds = new Set();
    prev.forEach((el) => {
        if (el.type === 'arrow' && s.has(el.id)) selectedArrowIds.add(el.id);
    });
    return prev.map((el) => {
        const direct = s.has(el.id);
        const viaArrow = !direct && el.attachedToArrow && selectedArrowIds.has(el.attachedToArrow);
        return { ...el, selected: direct || viaArrow };
    });
};

// Хук для управления выделением элементов
export const useSelection = () => {
    const [selectedElementId, setSelectedElementId] = useState(null);
    const [selectedElementIds, setSelectedElementIds] = useState(new Set());

    const handleElementSelect = (id, keep = false) => {
        setSelectedElementId(id);
        // Формируем актуальный набор выбранных id синхронно и используем его же для пометки selected
        let s;
        if (keep) {
            s = new Set(selectedElementIds);
            s.add(id);
        } else {
            s = new Set([id]);
        }
        setSelectedElementIds(s);

        return applySelection(s);
    };

    const handleElementSelectMultiple = (id, ev) => {
        if (ev.ctrlKey || ev.metaKey) {
            const s = new Set(selectedElementIds);
            if (s.has(id)) s.delete(id);
            else s.add(id);
            setSelectedElementIds(s);

            return applySelection(s);
        } else {
            const s = new Set([id]);
            setSelectedElementIds(s);
            setSelectedElementId(id);
            return applySelection(s);
        }
    };

    const clearSelection = () => {
        setSelectedElementId(null);
        setSelectedElementIds(new Set());
        return (prev) => prev.map((el) => ({ ...el, selected: false }));
    };

    const selectAll = (elements) => {
        const ids = new Set(elements.map((el) => el.id));
        setSelectedElementIds(ids);
        setSelectedElementId(null);
        return (prev) => prev.map((el) => ({ ...el, selected: true }));
    };

    return {
        selectedElementId,
        selectedElementIds,
        handleElementSelect,
        handleElementSelectMultiple,
        clearSelection,
        selectAll,
        setSelectedElementId,
        setSelectedElementIds
    };
};
